import { useState } from 'react';
import { ListMenuItem, MenuButton } from 'components/styles_components/menu';
import { LimitedSpan } from 'components/styles_components/span';
import { Menu, ListItemText, Box } from 'components/ui';
import { ArrowDropDownIcon, ArrowDropUpIcon, CheckIcon, AddIcon, ProbelistWorkspaceSwitchIcon } from 'components/uiIcons';
import { useSpace } from 'contexts/space';
import { FormattedMessage, useIntl } from 'react-intl';
import { DashboardLink, SpacesLink, hardRedirect } from 'utils/link';
import useResourceShow from 'hooks/use_resource_show';
import SpacesQuery from 'queries/space';

const SpaceSelector = ({ currentName }) => {
  const intl = useIntl();
  const { currentSpaceId, selectSpace, clearSpace } = useSpace();
  const [spaceAnchorEl, setSpaceAnchorEl] = useState(null);
  const spaceOpen = Boolean(spaceAnchorEl);

  const { data } = useResourceShow({
    query: SpacesQuery,
    fetchPolicy: 'cache-first',
    defaultData: { spaces: { spaces: [] }, invitedSpaces: { spacesTotal: 0 }, user: { canAddSpace: false } },
  });
  const spaces = data.spaces?.spaces ?? [];

  const handleSpaceClick = (event) => {
    setSpaceAnchorEl(event.currentTarget);
  };

  const handleSpaceClose = () => {
    setSpaceAnchorEl(null);
  };

  const onSpaceItemClick = (id) => {
    if (id === currentSpaceId) {
      handleSpaceClose();
      return;
    }
    selectSpace(id);
    hardRedirect(DashboardLink());
  };

  const onManageClick = () => {
    clearSpace();
    hardRedirect(SpacesLink());
  };

  const icon = spaceOpen ? (
    <ArrowDropUpIcon aria-hidden="true" />
  ) : (
    <ArrowDropDownIcon aria-hidden="true" />
  );

  return (
    <>
      <MenuButton
        aria-label={intl.formatMessage({ id: 'navbar.space' })}
        aria-haspopup="menu"
        aria-expanded={spaceOpen}
        aria-controls={spaceOpen ? 'space-selector-menu' : undefined}
        onClick={handleSpaceClick}>
        <ProbelistWorkspaceSwitchIcon aria-hidden="true" sx={{ mr: 1}} /><LimitedSpan>{currentName}</LimitedSpan> {icon}
      </MenuButton>
      <Menu
        id="space-selector-menu"
        anchorEl={spaceAnchorEl}
        open={spaceOpen}
        onClose={handleSpaceClose}>
        {spaces.map((space) => {
          const isCurrent = space.id === currentSpaceId;
          return (
            <ListMenuItem
              key={space.id}
              selected={isCurrent}
              onClick={() => onSpaceItemClick(space.id)}>
              {isCurrent ? (
                <CheckIcon aria-hidden="true" />
              ) : (
                <Box sx={{ width: 24 }} aria-hidden="true" />
              )}
              <ListItemText>{space.name}</ListItemText>
            </ListMenuItem>
          );
        })}
        {data.invitedSpaces?.spacesTotal > 0 && (
          <ListMenuItem onClick={onManageClick}>
            <AddIcon aria-hidden="true" />
            <ListItemText>
              <FormattedMessage id="spaces.invitations.title" />
            </ListItemText>
          </ListMenuItem>
        )}
        {data.user?.canAddSpace && (
          <ListMenuItem onClick={onManageClick}>
            <AddIcon aria-hidden="true" />
            <ListItemText>
              <FormattedMessage id="button.create_workspace" />
            </ListItemText>
          </ListMenuItem>
        )}
      </Menu>
    </>
  );
};

export default SpaceSelector;
